export const linkedInResumeDownloadLink =
    'https://www.linkedin.com/help/linkedin/answer/4281/saving-a-profile-in-a-pdf-format?lang=en';

export const trueFalseOptions = [
    { label: 'Yes', value: true, key: 'yes' },
    { label: 'No', value: false, key: 'no' },
];

export const yesNoOptions = [
    { label: 'Yes', value: 'Yes', key: 'yes' },
    { label: 'No', value: 'No', key: 'no' },
];

const yesNoOptionsWithNA = [...yesNoOptions];
yesNoOptionsWithNA.push({ label: 'N/A', value: 'N/A', key: 'NA' });
export { yesNoOptionsWithNA };

export const relevantBackgroundInfoQuestions = [
    {
        id: 1,
        name: 'felonyFirst',
        label:
            'In the past ten years, have you been convicted of or pled guilty or no contest in a court of law' +
            ' to any felony or misdemeanor involving: an investment or an investment-related business; fraud;' +
            ' false statement; theft; bribery; perjury or forgery?',
    },
    {
        id: 2,
        name: 'felony',
        label: 'In the past ten years, has any court or regulatory body,',
        children: [
            {
                id: 3,
                name: 'investmentActivity',
                label: 'Enjoined or barred you from participating in any investment-related activity?',
            },
            {
                id: 4,
                name: 'regulatoryInvestmentRegulation',
                label:
                    'Found that you were involved in a violation of federal or state securities laws or ' +
                    'other investment-related statutes or regulations?',
            },
            {
                id: 5,
                name: 'regulatorySettlement',
                label:
                    'Issued an order approving or accepting a settlement agreement related to any action ' +
                    'brought against you by a financial regulatory authority?',
            },
        ],
    },
    {
        id: 6,
        name: 'disciplinaryAction',
        label:
            'In the past ten years, have you been subject to any disciplinary action that has resulted ' +
            'in the revocation or suspension of a license or authorization to act as an attorney, accountant, ' +
            'investment adviser, medical doctor, federal contractor, or other licensed professional?',
    },
    {
        id: 7,
        name: 'terminatedEmployment',
        label:
            'In the past ten years, has your employment been terminated in connection with any allegation ' +
            'or conduct involving dishonesty, lack of integrity, or breach of confidence?',
    },
    {
        id: 8,
        name: 'investigation',
        label:
            "Are you now the subject of any investigation or proceeding that could result in a 'yes' answer " +
            'to any part of the previous questions?',
    },
    {
        id: 9,
        name: 'familyEmployment',
        label: 'Have you or any member of your family ever been an employee of the D. E. Shaw group?',
    },
    {
        id: 10,
        name: 'civilLawsuit',
        label: 'In the past five years, have you been a party (plaintiff or defendant) in any filed civil action or lawsuit?',
        descLabel:
            'Please provide the year, docket number, current status, and general description of the nature of the claim.',
    },
];
